<template>
  <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="row.toptitle" :width="700">
    <div class="electronicbilldetailed">
      <table class="QHtable">
        <tbody>
          <!--########################################车辆头部########################################-->
          <template v-if="$isblank(row.shipId)">
            <tr>
              <td colspan="6" align="center" style="font-size: 18px; font-weight: 700">
                <p v-if="row.garbageTypeName == '装修垃圾'">
                  装饰装修废弃物<span v-if="!$isblank(row.garbageName)">({{ row.garbageName }})</span>电子转移联单
                </p>
                <p v-if="row.garbageTypeName == '建筑垃圾'">
                  建筑工地废弃物<span v-if="!$isblank(row.garbageName)">({{ row.garbageName }})</span>电子转移联单
                </p>
                <p style="font-size: 14px; font-weight: normal; padding: 5px 0">联单编号:{{ row.NO }}</p>
                <p class="flex-center yunshuStatus" v-if="row.status == 100">
                  <span class="yunshuIcon iconfont icon-zhandianzhuangchebeifen flex-center" style=""></span>
                  <span>车辆{{ row.licensePlate }}正在装车</span>
                </p>
                <p class="flex-center yunshuStatus" v-if="row.status == 200">
                  <span class="yunshuIcon iconfont icon-yunshuzhong1 flex-center"></span>
                  <span>车辆{{ row.licensePlate }}正在运输</span>
                </p>
                <p class="flex-center yunshuStatus" v-if="row.status == 300">
                  <span class="yunshuIcon iconfont icon-xiehuo flex-center"></span>
                  <span>车辆{{ row.licensePlate }}正在卸车</span>
                </p>
                <p class="flex-center yunshuStatus status400" v-if="row.status == 400">
                  <span class="yunshuIcon iconfont icon-yunshuwancheng flex-center"></span>
                  <span>车辆{{ row.licensePlate }}已完成清运</span>
                </p>
              </td>
            </tr>
          </template>

          <!--########################################船舶头部########################################-->
          <template v-if="!$isblank(row.shipId)">
            <tr>
              <td colspan="6" align="center" style="font-size: 18px; font-weight: 700">
                <p v-if="row.garbageTypeName == '装修垃圾'">
                  装饰装修废弃物<span v-if="!$isblank(row.garbageName)">({{ row.garbageName }})</span>电子转移联单
                </p>
                <p v-if="row.garbageTypeName == '建筑垃圾'">
                  建筑工地废弃物<span v-if="!$isblank(row.garbageName)">({{ row.garbageName }})</span>电子转移联单
                </p>
                <p style="font-size: 14px; font-weight: normal; padding: 5px 0">联单编号:{{ row.NO }}</p>
                <p class="flex-center yunshuStatus" v-if="row.status == 100">
                  <span class="yunshuIcon iconfont icon-zhandianzhuangchebeifen flex-center" style=""></span>
                  <span>{{ row.licensePlate }}正在装船</span>
                </p>
                <p class="flex-center yunshuStatus" v-if="row.status == 200">
                  <span class="yunshuIcon iconfont icon-yunshuzhong1 flex-center"></span>
                  <span>{{ row.licensePlate }}正在运输</span>
                </p>
                <p class="flex-center yunshuStatus" v-if="row.status == 300">
                  <span class="yunshuIcon iconfont icon-xiehuo flex-center"></span>
                  <span>{{ row.licensePlate }}正在卸船</span>
                </p>
                <p class="flex-center yunshuStatus status400" v-if="row.status == 400">
                  <span class="yunshuIcon iconfont icon-yunshuwancheng flex-center"></span>
                  <span>{{ row.licensePlate }}已完成清运</span>
                </p>
              </td>
            </tr>
          </template>

          <!--########################################车辆船舶排放合规意见########################################-->
          <template>
            <tr>
              <td width="50px" rowspan="4" class="headA">排放合规意见</td>
              <td style="width: 90px" class="lable">排放意见</td>
              <td>
                <span class="CL2 iconfont icon-wenhao-quan" style="font-size: 14px" v-if="row.examinePaifangOrg == 100">
                  <font class="ML3">接收待审</font>
                  <font class="ML3">(排放方待审)</font>
                </span>
                <span class="CL5 iconfont icon-jujue" style="font-size: 14px" v-if="row.examinePaifangOrg == 300">
                  <font class="ML3">拒绝接收</font>
                  <font class="ML3 CL4" v-if="row.statusPaifangOrg == 300">(平台方核拒)</font>
                  <font class="ML3" v-else>(排放方拒绝)</font>
                </span>
                <span class="CL4 iconfont icon-tongyi" style="font-size: 14px" v-if="row.examinePaifangOrg == 200">
                  <font class="ML3">同意接收</font>
                  <font class="ML3 CL5" v-if="row.statusPaifangOrg == 200">(平台方核准)</font>
                  <font class="ML3" v-else>(排放方同意)</font>
                </span>
              </td>
            </tr>
            <tr>
              <td class="lable">接收意见</td>
              <td>
                <span class="CL2 iconfont icon-wenhao-quan" style="font-size: 14px" v-if="row.examineJieshouOrg == 100">
                  <font class="ML3">接收待审</font>
                  <font class="ML3">(接收方待审)</font>
                </span>
                <span class="CL5 iconfont icon-jujue" style="font-size: 14px" v-if="row.examineJieshouOrg == 300">
                  <font class="ML3">拒绝接收</font>
                  <font class="ML3 CL4" v-if="row.statusJieshouOrg == 300">(平台方核拒)</font>
                  <font class="ML3" v-else>(接收方拒绝)</font>
                </span>
                <span class="CL4 iconfont icon-tongyi" style="font-size: 14px" v-if="row.examineJieshouOrg == 200">
                  <font class="ML3">同意接收</font>
                  <font class="ML3 CL5" v-if="row.statusJieshouOrg == 200">(平台方核准)</font>
                  <font class="ML3" v-else>(接收方同意)</font>
                </span>
              </td>
            </tr>
            <tr>
              <td class="lable">运输意见</td>
              <td>
                <span class="CL5 iconfont icon-jujue" style="font-size: 14px" v-if="row.status < 400 && $isYunshuChaoshi(row.emissionTime)">
                  <font class="ML3">运输超时</font>
                </span>
                <span class="CL5 iconfont icon-jujue" style="font-size: 14px" v-else-if="row.examineJieshouOrg == 300 && $isblank(row.orgIdJieshou) && row.status > 200">
                  <font class="ML3">司机自建卸点且平台未认可</font>
                </span>
                <span class="CL2 iconfont icon-wenhao-quan" style="font-size: 14px" v-else-if="row.status < 300">
                  <font class="ML3">等待审核</font>
                </span>
                <span class="CL4 iconfont icon-tongyi" style="font-size: 14px" v-else>
                  <font class="ML3">运输正常</font>
                </span>
                <span class="QHset" style="margin-left:5px;" @click="$openLineMap(row.NO)" v-if="row.status>200">行车轨迹</span>
              </td>
            </tr>
            <tr>
              <td class="lable">卸点围栏</td>
              <td>
                <span class="CL2 iconfont icon-wenhao-quan" style="font-size: 14px" v-if="row.dianziweilanStatus == 100"><font class="ML3">等待审核</font></span>
                <span class="CL4 iconfont icon-tongyi" style="font-size: 14px" v-if="row.dianziweilanStatus == 200"><font class="ML3">卸点围栏之外</font></span>
                <span class="CL4 iconfont icon-jujue" style="font-size: 14px" v-if="row.dianziweilanStatus == 300"><font class="ML3">卸点围栏之内</font></span>
              </td>
            </tr>
          </template>

          <!--########################################车辆排放与运输信息########################################-->
          <template v-if="$isblank(row.shipId)">
            <!--########################################车辆排放信息########################################-->
            <tr>
              <td width="50px" rowspan="5" class="headA">排放信息</td>
              <td class="lable">排放垃圾</td>
              <td>
                {{ row.projectName }}{{ row.garbageTypeName }}<span v-if="!$isblank(row.garbageName)">({{ row.garbageName }})</span> {{ row.carNumber }}车{{ row.garbageNumber }}m³
              </td>
            </tr>
            <tr>
              <td class="lable">排放地址</td>
              <td>{{ row.qingYunStartAddressFull }}</td>
            </tr>
            <tr>
              <td class="lable">排放时间</td>
              <td>{{ $timeFmt(row.emissionTime, "YYYY-MM-DD HH:mm") }}</td>
            </tr>
            <tr>
              <td class="lable">排放联系</td>
              <td v-if="!$isblank(row.qingYunStartContactTel)">{{ row.qingYunStartContactName }} {{ row.qingYunStartContactTel }}</td>
              <td v-else>零散排放小量排放,客户不愿意提供电话</td>
            </tr>
            <tr>
              <td class="lable">出场照片</td>
              <td>
                <QHImgList :list="row.waste_img"></QHImgList>
                <QHImgList :list="row.qingyunhouImg"></QHImgList>
                <QHImgList :list="row.qingyunqianImg"></QHImgList>
                <QHImgList :list="row.qingYunStartCarImg"></QHImgList>
                <QHImgList :list="row.qingYunStartPingZhengImg"></QHImgList>
              </td>
            </tr>
            <!--########################################车辆运输信息########################################-->
            <tr class="contentB">
              <td rowspan="3" class="headA">运输信息</td>
              <td class="lable">运输单位</td>
              <td>{{ row.orgNameYunshu }}（{{ row.orgAddressYunshu }}）</td>
            </tr>
            <tr class="contentB">
              <td class="lable">运输司机</td>
              <td>{{ row.driverName }} {{ row.driverTel }}</td>
            </tr>
            <tr class="contentB">
              <td class="lable">运输工具</td>
              <td>{{ row.licensePlate }} {{ row.carName }} 容量{{ row.carCapacity }}m³</td>
            </tr>
          </template>

          <!--########################################船舶排放与运输信息########################################-->
          <template v-if="!$isblank(row.shipId)">
            <!--########################################排放信息########################################-->
            <tr>
              <td width="50px" rowspan="11" class="headA">排放信息</td>
              <td class="lable">排放单位</td>
              <td>{{ row.orgPaifang.name }}（{{ row.orgPaifang.addressDetailed }} {{ row.orgPaifang.contactName }}{{ row.orgPaifang.contactTel }}）</td>
            </tr>
            <tr>
              <td class="lable">排放垃圾</td>
              <td>
                {{ row.projectName }}（{{ row.qingYunStartAddressFull }}）{{ row.garbageTypeName }}<span v-if="!$isblank(row.garbageName)">({{ row.garbageName }})</span> 共计{{ row.carNumber }}船{{ row.garbageNumber }}m³
              </td>
            </tr>
            <tr>
              <td class="lable">排放地址</td>
              <td>{{ row.qingYunStartAddressFull }}</td>
            </tr>
            <tr>
              <td class="lable">排放电话</td>
              <td v-if="!$isblank(row.qingYunStartContactTel)">{{ row.qingYunStartContactName }} {{ row.qingYunStartContactTel }}</td>
              <td v-else>零散排放小量排放,客户不愿意提供电话</td>
            </tr>
            <tr>
              <td class="lable">排放时间</td>
              <td>{{ $timeFmt(row.emissionTime, "YYYY-MM-DD HH:mm") }}</td>
            </tr>
            <tr>
              <td class="lable">出场照片</td>
              <td>
                <QHImgList :list="row.waste_img"></QHImgList>
                <QHImgList :list="row.qingyunhouImg"></QHImgList>
                <QHImgList :list="row.qingyunqianImg"></QHImgList>
                <QHImgList :list="row.qingYunStartCarImg"></QHImgList>
                <QHImgList :list="row.ruchangcarImg"></QHImgList>
                <QHImgList :list="row.qingYunStartPingZhengImg"></QHImgList>
              </td>
            </tr>
            <!--########################################运输信息########################################-->
            <tr class="contentB">
              <td rowspan="7" class="headA">船舶信息</td>
              <td class="lable">船舶名称</td>
              <td>{{ row.ship.name }}{{ row.ship.shipCode }}</td>
            </tr>
            <tr class="contentB">
              <td class="lable">船舶规格</td>
              <td>
                载量{{ row.ship.capacity }}<br />
                长{{ row.ship.totalLength }}米,宽{{ row.ship.width }}米,型深{{ row.ship.depth }}米
              </td>
            </tr>
            <tr class="contentB">
              <td class="lable">船检登记号</td>
              <td>{{ row.ship.inspectionRegistrationNumber }}</td>
            </tr>
            <tr class="contentB">
              <td class="lable">有效期至</td>
              <td>{{ $timeFmt(row.ship.validityPeriod, "YYYY-MM-DD HH:mm") }}</td>
            </tr>
            <tr class="contentB">
              <td class="lable">所有单位</td>
              <td>{{ row.ship.owner }}</td>
            </tr>
            <tr class="contentB">
              <td class="lable">经营单位</td>
              <td>{{ row.ship.operator }} {{ row.ship.phoneNumber }}</td>
            </tr>
            <tr class="contentB">
              <td class="lable">许可证号</td>
              <td>{{ row.ship.licenseNumber }}</td>
            </tr>
          </template>

          <!--########################################车辆+船舶处置信息########################################-->
          <template v-if="!$isblank(row.orgNameJieshou)">
            <tr>
              <td rowspan="7" class="headA none">处置信息</td>
              <td class="lable">接收单位</td>
              <td>{{ row.orgNameJieshou }}</td>
            </tr>
            <tr>
              <td class="lable">接收地址</td>
              <td>{{ row.qingYunEndAddressFull }}</td>
            </tr>
            <tr>
              <td class="lable">接收垃圾</td>
              <td>
                {{ row.garbageTypeName }}<span v-if="!$isblank(row.garbageName)">({{ row.garbageName }})</span> {{ row.carNumber }}车{{ row.garbageNumber }}m³
              </td>
            </tr>
            <tr>
              <td class="lable">接收时间</td>
              <td>{{ $timeFmt(row.endTime, "YYYY-MM-DD HH:mm") }}</td>
            </tr>
            <tr>
              <td class="lable">处置方式</td>
              <td>{{ row.chuzhiWay }}</td>
            </tr>
            <tr>
              <td class="lable">送达凭证</td>
              <td>
                <QHImgList :list="row.ruchangcarImg"></QHImgList>
                <QHImgList :list="row.qingYunEndPingZhengImg"></QHImgList>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </Modal>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      show: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:唤起详细弹窗
    // +----------------------------------------------------------------------
    hiPop(e) {
      var parameter = { NO: e.NO };
      this.$loading(true);
      this.$api.getElectronicbillDetailed(parameter).then((res) => {
        this.$loading(false);
        if (res.code == 0) {
          this.row = res.data;
          this.show = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    mounted() {
      let that = this;
      var garbageName = "";
      if (!$isblank(that.row.garbageName)) {
        var garbageName = "(" + that.row.garbageName + ")";
      }
      if (that.row.garbageTypeName == "装修垃圾") {
        that.row.toptitle = "装饰装修废弃物" + garbageName + "电子转移联单";
      } else {
        that.row.toptitle = "建筑工地废弃物" + garbageName + "电子转移联单";
      }
    },
    // +----------------------------------------------------------------------
    // | Desc:生成小程序码
    // +----------------------------------------------------------------------
    artificialCode(id) {
      let that = this;
      console.log(id);
      this.$loading(true);
      that.$api.artificialCode({ id: id }).then((res) => {
        that.$loading(false);
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:生成出场凭证
    // +----------------------------------------------------------------------
    createdChuchangPingZheng(NO) {
      let that = this;
      this.$loading(true);
      that.$api.createdChuchangPingZheng({ NO: NO }).then((res) => {
        that.$loading(false);
        that.row.qingYunStartPingZhengImg = res.data;
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:生成入场凭证
    // +----------------------------------------------------------------------
    createdRuchangPingZheng(NO) {
      let that = this;
      this.$loading(true);
      that.$api.createdRuchangPingZheng({ NO: NO }).then((res) => {
        that.$loading(false);
        that.row.qingYunEndPingZhengImg = res.data;
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:操作下载
    // +----------------------------------------------------------------------
    DAOCHUPDF() {
      var html = "";
      html = html + "<p>(1)、第一步：请确认本页面是火狐浏览器访问！</p>";
      html = html + "<p>(2)、第二步：进入下载页面后等待全部图片加载完毕！</p>";
      html = html + "<p>(3)、第三步：按“ctrl+p”，启动PDF预览！</p>";
      html = html + "<p>(4)、第四步：打印机选择“另存为PDF文件”，边距选择“无”，选项不可勾选“打印页眉和页脚”！请勾选打印背景</p>";
      html = html + "<p>(5)、第五步：点击“保存”，等待保存完成！ </p>";
      this.$Modal.confirm({
        title: "导出提示",
        content: html,
        onOk: () => {
          const link = document.createElement("a");
          link.href = "/electronicbilldetailed?NO=" + this.row.NO;
          link.target = "_blank";
          link.click();
        },
      });
    },
  },
};
</script>
<style>
.electronicbilldetailed {
  max-width: 700px;
  margin: 0 auto;
  display: block;
}

.electronicbilldetailed td {
  color: #333;
  padding: 10px !important;
}

.electronicbilldetailed .lable {
  font-weight: 700;
  text-align: center !important;
}

.electronicbilldetailed .headA {
  text-align: center;
  color: #fff !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  background: #3975c6;
}

.electronicbilldetailed .headA.none:after {
  display: none;
}

.electronicbilldetailed .contentB {
  background: #f9f9f9;
}

.QHtable td {
  border-color: #eee;
}

.DAOCHU {
  color: #3975c6;
  margin-left: 5px;
  cursor: pointer;
}

.yunshuIcon {
  font-size: 22px;
  font-weight: normal;
  margin-right: 5px;
}

.yunshuStatus span {
  display: inline-block;
  line-height: 22px;
  padding: 5px 0;
  color: #ff9900;
}

.yunshuStatus.status400 span {
  color: #19be6b !important;
}
</style>
